var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.453,
    height: 192.748,
    viewBox: "0 0 215.453 192.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.274,
    y1: 0.967,
    x2: 0.756,
    y2: 0.102,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98c9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    stopColor: "#a8d1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#c7e2f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#e0eef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f1f7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fbfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.007,
    y1: 0.263,
    x2: 0.907,
    y2: 0.552,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98c9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#aed4eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#cbe3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#e0eef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#ecf4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f1f7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f7fd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.13,
    y1: 0.962,
    x2: 0.656,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98c9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#9dcbe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#bbdbee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#d4e8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#e7f2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#f4f9fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98c9e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#b6d8ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#ddedf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#f6fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-362.74 -194.977)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.076 381.876c-7.986 0-15.745-.693-23.06-2.06-8.508-1.588-16.715-4.142-24.392-7.589a72.532 72.532 0 0 1-17.735-11.313 76.325 76.325 0 0 1-11.594-12.586c-5.313-7.243-7.735-13.188-8.115-14.166-.38-2.017-4.016-21.484-6.233-41.124-.191-3.842-.749-15.351 2.896-28.928 2.065-7.693 5.163-14.875 9.208-21.346 4.914-7.86 11.298-14.777 18.974-20.555a79.444 79.444 0 0 1 25.337-12.763c7.82-2.313 16.125-3.485 24.685-3.485 7.159 0 14.59.848 21.49 2.452 5.385 1.252 10.458 2.978 13.918 4.735 1.257.639 2.685 1.314 4.339 2.096 3.6 1.702 8.08 3.82 12.829 6.56 5.546 3.2 10.303 6.572 14.542 10.309 5.242 4.619 9.664 9.824 13.143 15.47 4.081 6.623 7.006 14.073 8.692 22.144 2.984 14.28 4.354 26.062 4.188 36.019-.14 8.424-1.382 14.091-2.38 18.645-.433 1.98-.843 3.852-1.107 5.682l-1.08 6.163-.264 1.51 1.39.648c.028.013 2.801 1.309 5.656 2.973 4.758 2.773 5.578 4.115 5.697 4.366-.032.25-.372 1.759-3.959 5.549a68.105 68.105 0 0 1-4.401 4.22l-.045.04-.043.041c-.043.041-4.507 4.315-13.371 9.359-5.204 2.96-10.884 5.604-16.883 7.856-7.493 2.813-15.507 5.02-23.822 6.561-6.694 1.082-16.923 2.517-28.5 2.517Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.076 379.876c11.42 0 21.532-1.417 28.159-2.487 8.148-1.512 16.003-3.672 23.346-6.42 5.883-2.203 11.455-4.786 16.56-7.68 8.587-4.867 12.969-9 13.12-9.144l.076-.074.097-.083a66.868 66.868 0 0 0 3.853-3.661c2.069-2.138 3.041-3.494 3.487-4.236-.67-.606-2.07-1.682-4.872-3.28a77.972 77.972 0 0 0-4.998-2.604l-2.781-1.294.529-3.022 1.074-6.134c.274-1.891.69-3.787 1.13-5.793 1.029-4.7 2.195-10.027 2.332-18.251.164-9.806-1.192-21.443-4.145-35.577-7.034-33.663-33.751-46.297-48.104-53.084-1.667-.789-3.107-1.47-4.39-2.12-3.322-1.688-8.23-3.354-13.466-4.571-6.753-1.57-14.027-2.4-21.036-2.4-8.368 0-16.483 1.145-24.118 3.403a77.45 77.45 0 0 0-24.701 12.443c-7.48 5.63-13.697 12.365-18.481 20.017-3.94 6.303-6.96 13.303-8.973 20.805-3.543 13.2-3.023 24.421-2.832 28.247 2.154 19.062 5.647 37.955 6.169 40.732.505 1.268 2.847 6.79 7.797 13.537a74.32 74.32 0 0 0 11.289 12.256 70.535 70.535 0 0 0 17.246 11.002c7.533 3.382 15.588 5.888 23.94 7.448 7.195 1.344 14.83 2.025 22.693 2.025m0 4c-14.854 0-31.528-2.307-48.271-9.824-28.918-12.984-38.557-39.344-38.557-39.344s-3.93-20.525-6.295-41.508c-.393-7.869-2.361-46.819 31.869-72.589 16.853-12.688 35.332-16.65 51.225-16.65 16.385 0 30.023 4.208 36.314 7.404 12.394 6.295 46.335 18.413 54.597 57.953 8.262 39.541 2.169 50.969.718 61.07l-1.084 6.193s11.644 5.421 12.463 8.697c.819 3.276-9.01 11.74-9.01 11.74s-17.946 17.427-55.126 24.312c-8.2 1.325-18.04 2.546-28.843 2.546Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.162 334.334s11.813 5.517 12.632 8.793-9.009 11.74-9.009 11.74-17.947 17.427-55.127 24.312c-19.475 3.147-48.2 5.705-77.114-7.279s-38.557-39.343-38.557-39.343 24.984-17.312 17.9-36.59c-3.541-5.312-19.082-6.1-24.2-4.918-.393-7.869-2.36-46.819 31.869-72.589s75.146-15.541 87.54-9.246 40.917 22.426 49.179 61.966-.245 65.173-1.7 75.275c0 0 2.391 1.793 6.574-11.954 0 0 7.909-19.846 5.155-46.6s-12.2-50.36-31.278-68.261A90.448 90.448 0 0 0 474 195.05c-16.525-.59-36.787 2.164-59.8 16.131-23.409 15.344-32.262 43.868-33.836 48.983 0 0-4.643 17.43-1.967 31.868 1.941 10.469 6.1 38.164 6.1 38.164s5.9 26.754 37.179 44.065 69.836 12.983 69.836 12.983 29.311-2.36 48.786-12.2 28.327-17.115 32.852-22.426 5.705-9.639 4.721-11.41-8.458-8.34-17.721-12.928c-.693 2.601-1.988 6.054-1.988 6.054Z",
    fill: "#070303"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.234,
    cy: 26.169,
    rx: 44.234,
    ry: 26.169,
    transform: "rotate(-3.975 4453.9 -5484.97)",
    fill: "#e88ab6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#070303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.844 293.182a223.6 223.6 0 0 0-14.579 24.248c-7.066 13.687-9.075 17.48-10.785 21.2s-1.116 3.719-1.116 3.719.521.6 2.678-3.644S416.6 318.1 416.6 318.1l13.761-23.43s2.309-4.463-.517-1.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.7 295.528a188.732 188.732 0 0 0-11.831 20.342c-5.735 11.482-7.365 14.664-8.753 17.784s-.9 3.12-.9 3.12.422.5 2.173-3.057 8.571-17.285 8.571-17.285l11.167-19.656s1.873-3.744-.427-1.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.779 294.6a113.867 113.867 0 0 0-9.57 12.391c-4.639 6.994-5.957 8.933-7.08 10.833s-.733 1.9-.733 1.9.342.3 1.758-1.863 9.929-11.809 9.929-11.809l6.038-10.693s1.514-2.282-.342-.759Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.131 295.067a223.785 223.785 0 0 0-14.909 24.047c-7.253 13.588-9.313 17.354-11.075 21.049s-1.166 3.7-1.166 3.7.512.6 2.727-3.608 10.843-20.455 10.843-20.455l14.081-23.24s2.368-4.429-.501-1.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.857 295.769a223.64 223.64 0 0 0-14.691 24.181c-7.13 13.654-9.155 17.438-10.883 21.149s-1.133 3.714-1.133 3.714.518.6 2.694-3.632 10.656-20.555 10.656-20.555l13.868-23.367s2.332-4.452-.511-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.4 294.694a223.747 223.747 0 0 0-14.337 24.393c-6.93 13.756-8.9 17.569-10.574 21.3s-1.079 3.73-1.079 3.73.527.59 2.642-3.671 10.357-20.708 10.357-20.708l13.527-23.566s2.264-4.481-.536-1.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.15 291.273a223.675 223.675 0 0 0-14.337 24.392c-6.929 13.756-8.9 17.569-10.574 21.3s-1.078 3.73-1.078 3.73.526.59 2.641-3.671 10.357-20.708 10.357-20.708l13.527-23.566s2.261-4.48-.536-1.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.566 311.574c-6.93 13.756-8.9 17.569-10.574 21.3s-1.079 3.73-1.079 3.73.527.59 2.641-3.671 10.357-20.708 10.357-20.708-.036.175-1.345-.651Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.768 295.89a235.208 235.208 0 0 0-15.088 25.151c-7.339 14.211-9.424 18.149-11.206 22.013s-1.18 3.872-1.18 3.872.52.629 2.761-3.774 10.972-21.394 10.972-21.394l14.249-24.307s2.394-4.634-.508-1.561Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M506.447 284.423s-16.4-6.207-32.224-4.211-17.7 7.486-17.7 7.486-4.562 7.27 9.694 18.96a129.312 129.312 0 0 0 30.365 16.109",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.677 284.308s-16.507-6.054-32.336-4.1c-15 1.852-17.584 7.374-17.584 7.374s-4.562 7.27 9.694 18.96a129.3 129.3 0 0 0 30.364 16.109",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.447 284.423s-16.7-5.991-32.529-3.995-17.392 7.27-17.392 7.27-4.562 7.27 9.694 18.96a129.312 129.312 0 0 0 30.365 16.109s1.644.589 1.511 1.255c-.134 1.065-2.929 1.065-3.995 1.065a68.581 68.581 0 0 1-29.825-11.387c-13.456-9.456-18.426-21.093-15.517-28s12.244-9.94 19.517-11.031a66.144 66.144 0 0 1 19.76.121s11.979 2.341 17.147 6.6c3.894 3.196 1.264 3.033 1.264 3.033Z",
    fill: "#070303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.832 243.231-7.667-5.65a65.972 65.972 0 0 0-.337 11.232c.606 2.825 1.884 6.794 3.7 6.726s3.295-2.421 3.295-4.573-1.748-10.627 1.009-7.735Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.832 243.231s2.892 4.977 2.489 10.223-2.892 6.659-2.892 6.659a5.9 5.9 0 0 1-8.206-.471c-4.3-4.035-3.767-12.712-3.767-12.712s.807-8.744 3.027-10.9 1.682 1.547 1.682 1.547a65.972 65.972 0 0 0-.337 11.232c.606 2.825 1.884 6.794 3.7 6.726s3.295-2.421 3.295-4.573-1.748-10.623 1.009-7.731ZM468.34 351.308a80.113 80.113 0 0 0-13.881-1.239 38.167 38.167 0 0 0-12.765 2.85c-1.363.62-4.907.283-.5-3.594 4.535-3.985 17.475-3.222 18.714-2.974s6.445 1.239 8.552 2.85 2.111 2.099-.12 2.107Z",
    fill: "#070303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.591 310.073s-8.6 1.457-14.8 6.768c-1.833 1.5-2.021.658-2.068.423s-.329-3.431 4-7.1 6.157-3.9 8.742-4.183a17.3 17.3 0 0 1 4.126 4.092Z",
    fill: "#070303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.378 314.532s8.714.418 15.508 4.949c2 1.274 2.086.412 2.1.173s-.083-3.446-4.815-6.569-6.579-3.137-9.179-3.108a17.317 17.317 0 0 0-3.614 4.555Z",
    fill: "#070303"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.088 334.44a17.358 17.358 0 0 1-6.184-3.048c-1.682-1.294-3.197-2.927-4.502-4.853-2.24-3.306-3.06-6.276-3.069-6.306l-.005-.021-.006-.02a46.435 46.435 0 0 1-1.317-6.549c-.692-5.64.294-7.89.953-8.733.719-.864 1.638-1.66 2.735-2.37 5.481-3.546 13.515-3.85 13.596-3.853l.05-.002.049-.004c.01 0 1.2-.096 2.884-.096 1.699 0 4.189.099 6.404.57 2.117.45 3.584 1.162 4.132 2.003 1.13 1.736 1.75 5.345 1.58 9.196-.18 4.088-1.18 7.687-2.675 9.627-1.533 1.989-4.583 5.206-8.366 8.826-2.92 2.795-5.228 4.82-6.259 5.633Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.637 332.219c1.152-.976 3.074-2.694 5.529-5.05 3.618-3.474 6.521-6.539 7.963-8.409 1.216-1.578 2.104-4.912 2.262-8.494.172-3.908-.53-6.89-1.255-8.01-.03-.035-.624-.687-3.022-1.175-1.595-.325-3.616-.496-5.842-.496-1.59 0-2.712.089-2.72.09l-.09.008-.104.003c-.223.009-7.653.346-12.58 3.534-.912.59-1.672 1.242-2.257 1.938-.183.25-1.18 1.89-.537 7.192a44.437 44.437 0 0 0 1.256 6.277l.008.023.013.05c.05.174.878 2.953 2.933 5.916 2.27 3.273 5.105 5.488 8.443 6.603m.836 4.369c-12.51-2.695-16.07-15.832-16.07-15.832s-3.671-12.473 0-17.104c.904-1.092 2.002-2.014 3.204-2.791 6.01-3.889 14.616-4.173 14.616-4.173s1.25-.103 3.049-.103c3.863 0 10.255.477 12.212 3.482 2.868 4.404 2.602 16.219-1.187 21.135-3.79 4.916-14.778 15.04-15.824 15.386Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.868 343.348s-12.621 1.276-21.107-12.606c-8.015-13.3-9.29-30.786 4.008-36.068s20.584-4.19 20.584-4.19 11.658-.182 15.666 6.011-1.457 17.67-1.457 17.67-8.2 13.116-16.4 18.763a76 76 0 0 0 4.123 8.414 36.256 36.256 0 0 1-5.105 2.669s-5.137-8.814-5.853-13.628c3.174-2.765 9.422-7.374 13.212-12.29s8.808-13.622 5.94-18.026-15.261-3.379-15.261-3.379-12.392.409-17.82 6.964c-3.512 4.241 0 17.1 0 17.1s3.936 13.529 16.07 15.832c2.872 5.842 3.4 6.764 3.4 6.764Z",
    fill: "#070303"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooColored);
export default __webpack_public_path__ + "static/media/boo-colored.83a176c3e3506caa20969a4cfaf26cb4.svg";
export { ForwardRef as ReactComponent };